export const getDepthValue = (row, depthKey, plotFor) => {
  const key = plotFor.toLowerCase();
  const metricKey = `${key}_with_sbp`;

  if (row?.depths_summary) {
    return row?.depths_summary?.[depthKey]?.[metricKey] ?? null;
  }

  const oldMap = {
    casing_shoe: `icp_${key}`,
    landing_point: `lp_${key}`,
    hole_depth: `bh_${key}`,
  };

  if (oldMap[depthKey]) {
    return row?.[oldMap[depthKey]];
  }

  return row?.[`${depthKey}_${key}`];
};

export const getDepthValueFromField = (row, field) => {
  if (!field) return null;

  const metric = field.split('_').pop();
  const prefix = field.replace(`_${metric}`, '');

  const depthMap = {
    icp: 'casing_shoe',
    lp: 'landing_point',
    bh: 'hole_depth',
  };

  const depthKey = depthMap[prefix] ?? prefix;
  const metricKey = `${metric}_with_sbp`;

  if (row?.depths_summary) {
    return row?.depths_summary?.[depthKey]?.[metricKey] ?? 0;
  }

  return row?.[field] ?? 0;
};
